'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Really simple curry function that only supports up to two arguments.
// This keeps things very simple and very small.
var curry1 = function curry1(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.length >= 2 ? fn.apply(undefined, args) : function () {
      for (var _len2 = arguments.length, moreArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        moreArgs[_key2] = arguments[_key2];
      }

      return fn.apply(undefined, args.concat(moreArgs));
    };
  };
};

var negate = function negate(fn) {
  return function () {
    return !fn.apply(undefined, arguments);
  };
};

var isString = function isString(value) {
  return typeof value === 'string';
};
var isArray = function isArray(value) {
  return Array.isArray(value);
};
var isObject = function isObject(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !isArray(value);
};

var doesMatch = curry1(function (regex, string) {
  return regex.test(string);
});

var isSuffix = doesMatch(/^(--|__)/);
var isElement = doesMatch(/^__/);
var isModifier = doesMatch(/^--/);

// Returns an array of all keys in `obj` whose values are truthy
var truthyObjToArr = function truthyObjToArr(obj) {
  return Object.keys(obj).filter(function (key) {
    return !!obj[key];
  });
};

var buildError = function buildError(message) {
  return new Error('bemify - ' + message);
};

var splitClasses = function splitClasses(classes) {
  return (classes || '').split(/\s+/);
};

// Simple one-level flattening
var flattenReduce = function flattenReduce(flat, item) {
  return flat.concat(item);
};

// Takes `classes` which may be one of several types and returns
// an array of them with all falsy values filtered out.
var normalizeParts = function normalizeParts(classes) {
  var suffixes = [];
  if (isString(classes)) {
    suffixes = [classes];
  }
  if (isArray(classes)) {
    suffixes = classes.map(normalizeParts);
  }
  if (isObject(classes)) {
    suffixes = truthyObjToArr(classes);
  }
  return suffixes
  // flatten since `normalizeParts` is recursive when `isArray`
  .reduce(flattenReduce, []).map(splitClasses)
  // flatten since `splitClasses` could return nested arrays
  .reduce(flattenReduce, []).filter(Boolean).sort(); // facilitate testing
};

// Finds the *only* element in `suffixes` and prefixes it
// with `block`. If no elements are found in `suffixes`,
// `block` itself is used. The reason we only allow one
// element is because a BEM node should never be two BEM
// elements at once.
var getElement = function getElement(block, suffixes) {
  var els = suffixes.filter(isElement);
  if (els.length > 1) {
    throw buildError('Only a single element is allowed, but got ' + els.length + ' (' + els.join(', ') + ').');
  }
  return '' + block + (els[0] || '');
};

var bemify = curry1(function (block) {
  for (var _len3 = arguments.length, denormalizedSuffixes = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    denormalizedSuffixes[_key3 - 1] = arguments[_key3];
  }

  var suffixes = normalizeParts(denormalizedSuffixes);
  var element = getElement(block, suffixes);
  var prefix = function prefix(suffix) {
    return '' + element + suffix;
  };
  return [element].concat(_toConsumableArray(suffixes.filter(isModifier).map(prefix)), _toConsumableArray(suffixes.filter(negate(isSuffix)))).join(' ').trim();
});

exports.default = bemify;
var toModifiers = exports.toModifiers = function toModifiers() {
  for (var _len4 = arguments.length, classes = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  return normalizeParts(classes).map(function (c) {
    return '--' + c;
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/bemify-js/lib/bemify.js
// module id = 40
// module chunks = 0